import React, { FC, useState } from 'react'
// import './styles.scss'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'

// const checkIsMobile = window.innerWidth <= 599

export const ChartContainer: FC<{
  title?: string
  toggleNameLeft?: string
  toggleNameRight?: string
  dwChartIdLeft?: string
  dwChartIdRight?: string
}> = ({
  title,
  toggleNameLeft,
  toggleNameRight,
  dwChartIdLeft,
  dwChartIdRight,
}) => {
  const [isViewWorld, setViewWorld] = useState<boolean>(false)

  return (
    <GraphicContainer id='CasesWorldMap'>
      {title && <h3>{title}</h3>}

      <div className='toggleWrapper'>
        <div className='center'>
          {toggleNameLeft && (
            <div className={'label ' + (!isViewWorld ? '' : 'off')}>
              {' '}
              {toggleNameLeft}
            </div>
          )}
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isViewWorld}
              icons={false}
              onChange={() => {
                setViewWorld(!isViewWorld)
              }}
            />
          </div>
          {toggleNameRight && (
            <div className={'label right ' + (isViewWorld ? '' : 'off')}>
              {toggleNameRight}
            </div>
          )}
        </div>
      </div>

      <div
        className='switchMap'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isViewWorld ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isViewWorld ? 1 : 99,
            width: '100%',
          }}
        >
          <AutofitIFrame src={`//datawrapper.dwcdn.net/${dwChartIdRight}/`} />
          {/* <DataWrapperChart chartId='EQ9Ye' height={504} /> */}
        </div>
        <div
          style={{
            opacity: isViewWorld ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isViewWorld ? 99 : 1,
            width: '100%',
          }}
        >
          <AutofitIFrame src={`//datawrapper.dwcdn.net/${dwChartIdLeft}/`} />
          {/* <DataWrapperChart chartId='TSG3x' height={504} /> */}
        </div>
      </div>
    </GraphicContainer>
  )
}
const GraphicContainer = styled.div<{ tenant?: string }>`
  h3 {
    color: var(--text-color);
    margin: 0;
    padding-top: 1rem;
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 20px;
    background: var(--site-background);
    border-top: 3px solid var(--text-color);
  }

  .toggleWrapper,
  .bigToggleWrapper {
    font-family: var(--chart-font-stack);
    width: 100%;
    text-align: center;
    font-size: 0.9em;
    font-weight: 600;
    padding-top: 0.25em;
    padding-bottom: 1.5em;
    background: var(--site-background);

    // border-top: 1px solid #d6d7dd;
    display: inline-block;
    .toggleTitle {
      display: inline-block;
      width: 100%;
      margin-bottom: 1em;
    }
    .center {
      display: inline-block;
      margin-left: auto;
      margin-right: auto;
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: center;
    }
    .label {
      float: left;
      text-align: right;
      padding-right: 1em;
      min-width: 90px;
      width: calc(50% - 25px);
      line-height: 1.3em;
      color: var(--text-color);
      &.off {
        color: #999baa;
      }
      &.right {
        padding-left: 1em;
        text-align: left;
      }
    }

    .toggleContainer {
      display: flex;
    }
  }
  .optionsWrapper {
    clear: both;
    width: 100%;
    display: inline-block;
    // display: flex;
    // flex-flow: row wrap;
    // justify-content: flex-start;

    // margin-bottom: 2em;
    margin-top: 1em;
    border-top: 1px solid #d6d7dd;
    @media only screen and (max-width: 599px) {
      display: inline-block;
      margin-bottom: 0em;
      margin-top: 1em;
    }
  }
  .bigToggleWrapper {
    flex-grow: 1;
    flex-basis: 50%;
    width: 50%;

    line-height: 0;
    float: left;
    border-top: 0;
    padding: 0;
    padding-left: 1em;
    padding-right: 1em;
    margin-top: 1em;
    @media only screen and (min-width: 600px) {
      &:nth-child(2n + 1) {
        border-right: 1px solid #d6d7dd;
      }
    }
    @media only screen and (max-width: 599px) {
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 1em;
      border-right: 0;
      border-bottom: 1px solid #d6d7dd;
    }
    .toggleContainer {
      min-width: 50px;
    }
    .toggleTitle {
      margin: 0;
    }
    .label {
      width: auto;
      padding-top: 0.2em;
      font-weight: 700;
      min-width: initial;
      min-width: calc(50% - 25px);
      max-width: calc(50% - 25px);
      font-size: 0.9em;
      &.off {
        font-weight: 400;
      }
      @media only screen and (max-width: 599px) {
        min-width: calc(50% - 25px);
        font-size: 1em;
      }
    }
    .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
      background-color: #000;
      @media only screen and (max-width: 599px) {
        background-color: #d6d7dd;
      }
    }
    .react-toggle:active:not(.react-toggle--disabled) .react-toggle-track {
      background-color: #000;
      @media only screen and (max-width: 599px) {
        background-color: #d6d7dd;
      }
    }

    // .react-toggle--checked {
    //   .react-toggle-track {
    //     background-color: #d6d7dd;
    //   }
    // }
  }
  .bigToggleWrapper:last-of-type {
    // border-right: 0;
    // padding-right: 0;
    border-bottom: 0;
  }
  .bigToggleWrapper:first-of-type {
    margin-left: 0;
    // padding-left: 0;
  }
  // CSS FÜR DEN SCHALTER
  .react-toggle {
    touch-action: pan-x;
    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .react-toggle--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    -webkit-transition: opacity 0.25s;
    transition: opacity 0.25s;
  }

  .react-toggle-track {
    width: 50px;
    height: 24px;
    padding: 0;
    border-radius: 30px;
    background-color: #c8c8d1;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #000000;
  }

  .react-toggle--checked .react-toggle-track {
    background-color: #202346;
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #202346;
  }

  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  .react-toggle-thumb {
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    position: absolute;
    top: 1px;
    left: 1px;
    width: 22px;
    height: 22px;
    border: 1px solid #4d4d4d;
    border-radius: 50%;
    background-color: #fafafa;

    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    transition: all 0.25s ease;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 27px;
    border-color: #202346;
  }

  .react-toggle--focus .react-toggle-thumb {
    -webkit-box-shadow: 0px 0px 3px 2px #0099e0;
    -moz-box-shadow: 0px 0px 3px 2px #0099e0;
    box-shadow: 0px 0px 2px 3px #0099e0;
  }

  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
    -webkit-box-shadow: 0px 0px 5px 5px #0099e0;
    -moz-box-shadow: 0px 0px 5px 5px #0099e0;
    box-shadow: 0px 0px 5px 5px #0099e0;
  }
`
